import React from "react";
import { renderGenericPageContent } from "../utilities/renderContent";
import { graphql } from "gatsby";
import SEO from "../components/seo";
import Impact from "../components/impact/universalTracking";

export default function OutfitterProgram({ data }) {
  return (
    <section>
      <Impact />
      <SEO title={data.datoCmsOutfittersProgram.title} description={data.datoCmsOutfittersProgram.description} />
      {renderGenericPageContent(data.datoCmsOutfittersProgram.pageContent)}
    </section>
  );
}

export const outfitterProgramQuery = graphql`
  query {
    datoCmsOutfittersProgram {
      title
      description
      pageContent {
        ...HeroComponent
        ...CopyComponent
        ...HubspotFormComponent
      }
    }
  }
`;
